// Lightweight anonymous usage tracking for the admin dashboard.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const VISITOR_KEY = "idiag-visitor-id";

export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export async function trackView(path, lang) {
  try {
    await fetch(`${BACKEND}/api/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: path || "/",
        visitor_id: getVisitorId(),
        lang: lang || "es",
      }),
      keepalive: true,
    });
  } catch {
    /* analytics must never break the app */
  }
}
